<template>
  <card class="card" title="Agregar tareas">
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Ruta directorio*"
              placeholder="Ruta directorio"
              v-model="form.path"
              :class="{
               'is-invalid': submitted && $v.form.path.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.path.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.path.required"
                >La ruta del directorio es requerida</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="date"
              label="Fecha inicio*"
              v-model="form.start_date"
              min="2018-01-01"
              :max='currentDate'
              :class="{
               'is-invalid': submitted && $v.form.start_date.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.start_date.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.start_date.required"
                >La fecha es requerida</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label>Extensiones*</label>
            <vSelect 
              :options="extension"
              placeholder="Selecciona una extensión*"
              v-model="form.format"
              :class="{
               'is-invalid': submitted && $v.form.format.$error
              }"
              />
            <div
              v-if="submitted && $v.form.format.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.format.required"
                >Requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <label>Tipo de respaldo*</label>
            <vSelect 
              :options="tipoR"
              placeholder="Selecciona un tipo de respaldo*"
              v-model="form.type"
              :class="{
               'is-invalid': submitted && $v.form.type.$error
              }"
              />
            <div
              v-if="submitted && $v.form.type.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.type.required"
                >Requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label>Periodos*</label>
            <vSelect 
              :options="periodos"
              placeholder="Selecciona un periodo*"
              v-model="form.period"
              :class="{
               'is-invalid': submitted && $v.form.period.$error
              }"
              />
            <div
              v-if="submitted && $v.form.period.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.period.required"
                >Requerido</span
              >
            </div>
          </div>
          <div class="col-md-6" :hidden="disabledSelect">
            <label>Seleccona una estación*</label>
            <vSelect 
                :options="stations"
                placeholder="Selecciona una estación*"
                v-model="station_id"
                v-on:input="handleSelectStation($event)"
              />
          </div>
        <!-- </div>
        <div class="row"> -->
          <div class="col-md-6">
            <label>Configuración por estación*</label>
            <vSelect 
              :options="configurations"
              placeholder="Selecciona una configuración*"
              v-model="form.configuration_id"
              :class="{
               'is-invalid': submitted && $v.form.configuration_id.$error
              }"
              :disabled="!hiddenStations"
              />
            <div
              v-if="submitted && $v.form.configuration_id.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.configuration_id.required"
                >Requerido</span
              >
            </div>
          </div>
        </div>

        <div><br/>
          <p-button 
            type="info" 
            @click.native.prevent="handleSubmit"
            style="margin-right: 10px;"
            >
            Enviar
          </p-button>
          <p-button type="danger" @click.native.prevent="handleCancel">
            Cancelar
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import backupTaskService from '../../services/backupTaskService'
import "vue-select/dist/vue-select.css";
import state from "../../store/state"
import vSelect from "vue-select";
import store from "../../store";
import { dateFormat } from "../../helpers";

import configurationsService from '../../services/configurationsService'
export default {
  components:{
    vSelect
  },
  data() {
    return {
      extension:["zip", "txt", "pdf", "rar", "bck", "xml", "cv", "json"],
      tipoR:["Factura", "Pemex", "Respaldo", "Póliza", "Otros"],
      periodos:["Diario", "Semanal", "Quincenal", "Mensual", "Bimestral"],
      configurations: [],
      form: {
        version: 0,
        start_date: "",
        path: "",
        period: "",
        type: "",
        configuration_id: "",
        format: ""
      },
      submitted: false,
      currentDate: dateFormat().toString(),
      stations: [],
      station_id: localStorage.getItem('stationId') ? localStorage.getItem('stationId') : null,
      disabledSelect: localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'SUPPORT' ? true : false,
      hiddenStations: localStorage.getItem('role') === 'ADMIN' || localStorage.getItem('role') === 'SUPPORT' ? true : false
   };
  },
  mounted () {
    if(
      localStorage.getItem('stationsJSON') &&
      JSON.parse(localStorage.getItem('stationsJSON')).length > 0
    ) {
        this.stations = localStorage.getItem('stationsJSON') 
          ? JSON.parse(localStorage.getItem('stationsJSON')) : []
    } else {
      setTimeout(() => {
        this.stations = state.stations.select
      }, 2000)
    }

    if(
      localStorage.getItem('role') === 'ADMIN' ||
      localStorage.getItem('role') === 'SUPPORT'
    ) {
      this.disabledSelect = false
      this.hiddenStations = false
    } else {
      this.disabledSelect = true
      this.hiddenStations = true
    }

    this.getConfig()
  },
  validations: {
    form: {
      start_date: { required },
      path: { required },
      period: { required },
      type: { required },
      configuration_id: { required },
      format: { required }
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      backupTaskService.create(this.form).then(response => {
        if(response.data.error === false) {
          state.tasks.list = []
          store.dispatch('actionGetTasks');
          swal({
            title: 'Exitoso',
            text: 'Se creo la tarea correctamente', 
            icon: 'success', 
            timer: 3000, 
            buttons: false
          })
          setTimeout(()=> {
            this.$router.push("/tareas-estacion");
          }, 3000)
        } else {
          swal({
            title: '¡Algo salio mal!',
            text: 'Consulte con el administrador', 
            icon: 'warning', 
            timer: 3000, 
            buttons: false
          })
        }
      })
    },
    handleCancel() {
      swal({
        title: '¡Aviso!',
        text: 'Se perdera tu progreso actual',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          this.$router.push("/tareas-estacion");
        }
      })
    },
    async handleSelectStation(data) {
      console.log(data)
      if(!data) {
        this.disabledSelect = false
      } else {
        const resp = await configurationsService.getConfigurations(0, '', data, 1000)
        console.log(resp)
        const configurations = resp.data.data.content.map((element, i) => {
          const data = {
              label: element.name,
              option: element.id,
              id: element.id
          }

          return data
        })

        this.configurations = configurations
        this.disabledSelect = false
        this.hiddenStations = true
      }
    },
    async getConfig() {
      if(localStorage.getItem('role') === 'STATION') {
        const resp = await configurationsService.getConfigurations(0, '', this.station_id, 1000)
        const configurations = resp.data.data.content.map((element, i) => {
          const data = {
            label: element.name,
            option: element.id,
            id: element.id
          }
          return data
        })

        this.configurations = configurations
      } 
    }
  }
};
</script>
<style></style>
